import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/merch-ui/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/BrowserPolyfills.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/ClientPageFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/ClientPageHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/DataDogInitClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/MfeEventsListener.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/MicroFrontendClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/PendingCookiesClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/appRouter/SpaNavigationListener.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/ComposerUi/ComposerUiMfe.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/merch-ui/src/components/common/GoogleTagManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterExperimentContextProvider"] */ "/home/vsts/work/1/s/merch-ui/src/context/common/FooterExperimentContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalLayoutProvider"] */ "/home/vsts/work/1/s/merch-ui/src/context/common/GlobalLayoutContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ComposerContextProvider"] */ "/home/vsts/work/1/s/merch-ui/src/context/composer/ComposerContext.tsx");
